import { useCallback, useContext } from 'react'
import { useAppSelector } from 'reduxTyped'

import { OnImprovementSubmit } from 'apps/aiTextImprover/lib/signatures'
import { BuilderIdContext } from 'common/builder/components/builder/BuilderIdProvider'
import { getById } from 'common/builder/selectors/builder/builderStateSelectors'
import { exportString } from 'components/MCTextEditor/dataFormat/exporter'
import MCEditorContext from 'components/MCTextEditor/MCEditorContext'
import { IToolHandler } from 'components/MCTextEditor/types'
import { EditorContext } from 'components/RichTextEditor/EditorContext'

export const useEditorAiTextImprover = ({ onSelect }: { onSelect?: IToolHandler }) => {
  const editorContext = useContext(EditorContext)
  const mcEditorContext = useContext(MCEditorContext)
  const text = exportString(editorContext.processor.getState())

  const builderId = useContext(BuilderIdContext)
  const builderState = useAppSelector((state) => getById(state, builderId.builderId))

  const replaceText: OnImprovementSubmit = useCallback(
    ({ text, isFinished }) => {
      const value = exportString(editorContext.processor.getState())
      editorContext.processor.delete(0, value.length)

      onSelect?.(text, undefined, { closeTool: isFinished, shouldFocus: isFinished })
    },
    [editorContext.processor, onSelect],
  )

  return {
    replaceText,
    maxLength: mcEditorContext.toolbar.limit || 1000,
    text,
    flowNs: builderState?.flow,
  }
}
